import { Instance } from 'mobx-state-tree';
import moment from 'moment';
import getAppRoot from '../utils/getAppRoot';
import { ProjectDtoModelBase } from './ProjectDtoModel.base';

/* The TypeScript type of an instance of ProjectDtoModel */
export interface ProjectDtoModelType extends Instance<typeof ProjectDtoModel.Type> {
}

/* A graphql query fragment builders for ProjectDtoModel */
export { selectFromProjectDto, projectDtoModelPrimitives, ProjectDtoModelSelector } from './ProjectDtoModel.base';

/**
 * ProjectDtoModel
 */
export const ProjectDtoModel = ProjectDtoModelBase
  .views((self) => ({
    get isSelected(): boolean {
      return self.id === getAppRoot(self).ui.selectedWorkspace?.id;
    },
    formattedDate(isBigScreen = true): string | undefined {
      if (self.startDate) {
        const date = moment.utc(self.startDate);
        const dateFormat = isBigScreen ? 'dddd, MMMM D' : 'ddd, MMM D';
        const yearFormat = date.year() !== moment().year() ? ', YYYY' : '';

        return date.format(dateFormat + yearFormat);
      }
      return undefined;
    },
  }))
  .actions(self => ({
    setVisitGeocodingCount(count: number) {
      self.visitGeocodingCount = count;
    },
  }));
